import { theming } from "@staccx/bento"

theming.theme.append({
  spacing: {
    huge: "4rem",
    large: "2rem",
    mediumPlus: "1.333333333rem",
    medium: "1rem",
    small: "0.5rem",
    tiny: "0.25rem",
    micro: "0.125rem",
    flush: "0rem"
  },
  borderRadius: "2px"
})
